<template>
  <div>
    <div
      class="row mb-1 pb-3 mb-3 border-bottom g-0"
      style="--bs-border-color: black"
    >
      <div class="col-md-12 d-flex align-items-center">
        <span class="fw-bold">Pemenuhan Kewajiban Pemegang PKKPRL/KKKPRL</span>
      </div>
    </div>

    <div class="d-flex">
      <div class="flex-grow-1">
        <div v-for="(item, index) in formTitle" :key="index">
          <template v-if="currentPage === 12 && index === 11">
            <formPemenuhan12 ref="form" :formTitle="item" :page="index + 1" />
          </template>
          <template v-else-if="currentPage === 13 && index === 12">
            <formPemenuhan13 ref="form" :formTitle="item" :page="index + 1" />
          </template>
          <template v-else-if="currentPage === index + 1">
            <formPemenuhan1 ref="form" :formTitle="item" :page="index + 1" />
          </template>
        </div>
      </div>
      <div class="ml-4 px-4 border-left">
        <div class="sticky-top" style="width: 170px; top: 50px">
          <div class="text-center fw-bold">({{ currentPage }}/16 halaman)</div>
          <div class="row g-0 mt-3">
            <div
              v-for="(item, index) in progressForm"
              class="col-3 p-1"
              style="height: 50px"
            >
              <div
                @click="nextPage(index + 1)"
                :class="[
                  'd-flex btn p-0',
                  {
                    'btn-primary': index + 1 === currentPage,
                    'btn-secondary':
                      item === 0 && index + 1 === lastActivePage + 1,
                    'btn-secondary disabled':
                      item === 0 && index + 1 !== lastActivePage + 1,
                    'btn-success': item === 1 && index + 1 !== currentPage,
                  },
                ]"
                style="width: 100%; height: 100%"
              >
                <div class="m-auto">
                  {{ index + 1 }}
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <div class="btn-group mr-2" role="group" aria-label="First group">
              <button
                type="button"
                :class="[
                  'btn',
                  { 'btn-primary': currentPage !== 1 },
                  { 'btn-secondary disabled': currentPage === 1 },
                ]"
                @click="nextPage(1)"
              >
                &laquo;
              </button>
              <button
                type="button"
                :class="[
                  'btn',
                  { 'btn-primary': currentPage !== 1 },
                  { 'btn-secondary disabled': currentPage === 1 },
                ]"
                @click="nextPage(currentPage - 1)"
              >
                &lsaquo;
              </button>
              <button
                type="button"
                :class="[
                  'btn',
                  { 'btn-primary': currentPage !== 16 },
                  { 'btn-secondary disabled': currentPage === 16 },
                ]"
                @click="nextPage(currentPage + 1)"
              >
                &rsaquo;
              </button>
              <button
                type="button"
                :class="[
                  'btn',
                  { 'btn-primary': currentPage !== 16 },
                  { 'btn-secondary disabled': currentPage === 16 },
                ]"
                @click="nextPage(16)"
              >
                &raquo;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="d-flex justify-content-center">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        prev-text="Sebelumnya"
        next-text="Selanjutnya"
        @page-click="nextPage"
      ></b-pagination>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
import formPemenuhan1 from './formPemenuhan/formPemenuhan1.vue'
import formPemenuhan12 from './formPemenuhan/formPemenuhan12.vue'
import formPemenuhan13 from './formPemenuhan/formPemenuhan13.vue'
import Vue from 'vue'

export default {
  components: {
    formPemenuhan1,
    formPemenuhan12,
    formPemenuhan13,
  },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      rows: 16,
      perPage: 1,
      currentPage: 1,
      formTitle: [
        '1. Memperhatikan keberlanjutan kehidupan dan penghidupan Masyarakat',
        '2. Memberikan akses untuk nelayan kecil yang sudah secara rutin melintas',
        '3. Menghormati kepentingan pihak lain yang melakukan kegiatan atau Pemanfaatan Ruang di sekitarnya',
        '4. Melakukan kegiatan secara ramah lingkungan',
        '5. Menjaga kelestarian ekosistem Laut dan melakukan rehabilitasi sumber daya yang mengalami kerusakan',
        '6. Menjaga kehidupan dan alur migrasi biota laut',
        '7. Memberikan akses/tempat berlindung kepada siapapun dalam kondisi darurat',
        '8. Melibatkan dan memberdayakan Masyarakat sekitar lokasi kegiatan/usaha',
        '9. Membongkar bangunan dan instalasi di Laut apabila masa berlaku telah habis dan kegiatan/usaha tidak dilanjutkan lagi',
        '10. Tidak menimbulkan konflik sosial',
        '11. Tidak menimbulkan gangguan bagi pelaksanaan kepentingan keselamatan, pertahanan keamanan, dan memperhatikan kepentingan nasional',
        '12. Menyampaikan laporan perolehan Perizinan Berusaha/Perizinan Non Berusaha',
        '13. Menyampaikan laporan secara tertulis setiap 1 (satu) tahun kepada Menteri yang paling sedikit memuat:',
        '14. Bermitra dengan penglola Kawasan Konservasi di Laut dalam rangka program kemitraan dan bina lingkungan dalam hal lokasi kegiatan berada dalam Kawasan Konservasi di Laut',
        '15. Melaporkan pendirian dan/atau penempatan Bangunan dan Instalasi di Laut kepada instansi yang menyelenggarakan urusan pemerintahan di bidang hidrografi dan oseanografi',
        '16. Menyediakan prasarana dan sarana pencegahan pencemaran dan pencegahan kerusakan sumber daya ikan serta lingkungannya',
      ],
      progressForm: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      lastActivePage: 1,
    }
  },
  methods: {
    async nextPage(page) {
      if (this.currentPage < page) {
        await this.$refs.form[0].nextForm().then(async (res) => {
          if (res) {
            const lastPage = await this.checkProgressForm()
            if (page === 16) {
              if (this.currentPage === 15 || lastPage === 16) {
                this.currentPage = 16
              } else {
                this.currentPage = lastPage + 1
              }
            } else if (page === 1) {
              this.currentPage = 1
            } else {
              this.currentPage = page
            }
          }
        })
      } else {
        if (page === 1) {
          this.currentPage = 1
        } else {
          if (Math.abs(page - this.currentPage) === 1) {
            this.currentPage -= 1
          } else {
            this.currentPage = page
          }
        }
      }

      if (this.currentPage === 16) {
        document.getElementById('btn_finish').style.visibility = 'visible'
      } else {
        document.getElementById('btn_finish').style.visibility = 'hidden'
      }
      setTimeout(() => {
        $('html,body').scrollTop(0)
      }, 100)
    },

    async nextForm() {
      if (this.currentPage === 16) {
        const statusLaporan = await axios
          .get(
            this.baseapi +
              `api/laporan_tahunan/${this.$route.query.id_laporan}`,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((res) => res.data.data.status_laporan)
        if (
          statusLaporan ===
          'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
        ) {
          return true
        }

        return this.$refs.form[0].nextForm().then(async (res) => {
          return res
        })
      } else {
        return false
      }
    },

    async checkProgressForm() {
      return axios
        .get(
          this.baseapi + `api/laporan_tahunan/${this.$route.query.id_laporan}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          const data = res.data.data
          let lastProgress = 1
          for (let i = 0; i < this.progressForm.length; i++) {
            if (i === 12) {
              if (data[`kemajuan_persetujuan_lingkungan_${i + 1}`]) {
                Vue.set(this.progressForm, i, 1)
                lastProgress = i + 1
              }
            } else {
              if (data[`status_kewajiban_${i + 1}`]) {
                Vue.set(this.progressForm, i, 1)
                lastProgress = i + 1
              }
            }
          }
          this.lastActivePage = lastProgress
          return lastProgress
        })
    },
  },
  mounted() {
    this.checkProgressForm()
  },
}
</script>
